// The Chats layout's sidebar (#141): the server menu (which also holds Apps, Collections, New channel and New
// category), the list of every chat in every server, and my name. No banner and no unread pills here: those belong to
// the Classic layout. Chosen in web/src/sidebars.ts.
import { useState } from "react";
import { CloseButton } from "../icons.tsx";
import { ServerMenu } from "../ServerMenu.tsx";
import type { SidebarProps } from "../SidebarProps.ts";
import type { ChatRow } from "../../chatsLogic.ts";
import { ChatList } from "./ChatList.tsx";
import { NewChannelDialog } from "../NewChannelDialog.tsx";

export function ChatsSidebar(p: SidebarProps & { chats: ChatRow[]; chatNames: Map<string, string> }) {
  /** New channel or New category (server menu, owners and admins). */
  const [making, setMaking] = useState<"channel" | "category" | null>(null);
  return (
    <>
      <aside className="sidebar" aria-label="Chats">
        <div className="sidebar-head">
          <ServerMenu
            {...p.menu}
            collections={p.collections}
            openCollection={p.openCollection}
            appsOpen={p.inApps}
            onApps={p.onApps}
            onCollection={p.onCollection}
            onNewCollection={p.onNewCollection}
            onNewChannel={p.isAdmin ? () => { p.onCloseDrawer(); setMaking("channel"); } : undefined}
            onNewCategory={p.isAdmin ? () => { p.onCloseDrawer(); setMaking("category"); } : undefined}
          />
          {p.canInvite && <button className="btn btn-small" onClick={p.onInvite}>Invite</button>}
          <button type="button" className="icon-btn compose-btn" onClick={p.onNewDm} aria-label="New message" title="New message">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" /></svg>
          </button>
          <CloseButton className="mobile-only" onClick={p.onCloseDrawer} aria-label="Close menu" />
        </div>
        <div className="sidebar-scroll">
          <div className="channels">
            <ChatList
              chats={p.chats}
              servers={p.servers}
              me={p.me}
              names={p.chatNames}
              online={p.online}
              serverId={p.serverId}
              activeId={p.inApps || p.inBloom ? undefined : p.activeId}
              onOpen={(c) => {
                if (c.serverId === p.serverId) p.onNavigate();
                else p.onCloseDrawer();
              }}
              onCloseDm={(c) => p.onCloseDm(c.channelId, c.lastSeq)}
              onMenu={p.onConversationMenu}
            />
          </div>
        </div>
        {p.footer}
      </aside>
      {making && (
        <NewChannelDialog
          kind={making}
          categories={p.categories}
          onClose={() => setMaking(null)}
          onCreate={(name, categoryId) => (making === "category" ? p.createCategory(name) : p.createChannel(name, categoryId))}
        />
      )}
    </>
  );
}
